
/* eslint-disable */
const UA = navigator.userAgent.toLowerCase();
export const IS_WECHAT = /micromessenger/i.test(UA);
export const isApp = /meishakeji/.test(UA); // App环境
export const isIos = /iphone|ipad|ipod|ios/.test(UA); // ios环境
export const isAndroid = UA.indexOf('android') > 0; // Android环境
// isApp &&
let firstEnter = true;

export const isLogin = false;

/**
 * 检测安卓的方法是否存在
 * @param {any} callback
 */
export function connectWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    callback(WebViewJavascriptBridge);
  } else {
    document.addEventListener(
      'WebViewJavascriptBridgeReady',
      function() {
        callback(WebViewJavascriptBridge);
      },
      false
    );
  }
}

/**
 * 无回调的APP方法
 * @param {string} name 方法名称
 * @param {*} data 方法数据
 */
export function appMethod (name, data = {}) {
  console.log(`appMethod ${name} ${JSON.stringify(data)}`);
  return new Promise((resolve, reject) => {
    if (!isApp) reject(new Error('不在App环境中'));
    else {
      try {
        if (isAndroid) {
          connectWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(name, data, function() {});
            resolve();
          });
        } else if (isIos) {
          window.webkit.messageHandlers[name].postMessage(data);
          resolve();
        } else {
          resolve();
        }
      } catch (error) {
        console.log('error', error);
        reject(error);
      }
    }
  });
}

/**
 * 有回调的App方法
 * @param {String} name 方法名称
 * @param {*} data 传递的数据
 * @param {Object} options 可定义的参数
 */
export function appCallbackMethod (name, data = {}, options = {}) {
  console.log(`appCallbackMethod ${name} ${JSON.stringify(data)}`);
  return new Promise((resolve, reject) => {
    if (!isApp) reject(new Error('不在App环境中'));
    else {
      if (isIos) {
        iosSetCallbackMethod(name, data, resolve, reject, options);
      } else if (isAndroid) {
        androidSetCallbackMethod(name, data, resolve, reject, options);
      }
    }
  });
}
export function iosSetCallbackMethod(name, data, resolve, reject, options) {
  try {
    let methodName = options.isOld ? name : `${name}Callback`;
    window[methodName] = function (responseData) {
      if (options.resIsObject) responseData = resloveAppCallbackData(responseData);
      resolve(responseData); // resolve一次后即无效，Promise的设计缘故
    };
    window.webkit.messageHandlers[name].postMessage(data);
  } catch (error) {
    reject(error);
  }
}
export function androidSetCallbackMethod(name, data, resolve, reject, options) {
  try {
    let methodName = options.isOld ? name : `${name}Callback`;
    console.log('enter Android set');
    connectWebViewJavascriptBridge(function(bridge) {
      console.log('enter  connectWebViewJavascriptBridge');
      if (firstEnter) {
        firstEnter = false;
        bridge.init(function(message, responseCallback) {
          var data = {
            'Javascript Responds': 'Wee!'
          };
          responseCallback(data);
        });
      }
      bridge.callHandler(name, data, function (responseData) {
        if (options.resIsObject) responseData = resloveAppCallbackData(responseData);
        resolve(responseData);
      });
      if (options.register) {
        bridge.registerHandler(methodName, function (responseData) {
          if (options.resIsObject) responseData = resloveAppCallbackData(responseData);
          resolve(responseData);
        });
      }
    });
  } catch (error) {
    reject(error);
  }
}

function resloveAppCallbackData (data) {
  if (typeof data !== 'object') {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        console.log('解析app返回数据时出错', data);
        data = {};
      }
    } else {
      console.log('app返回数据时不是Object/String', data);
      data = {};
    }
  }
  return data;
}
